import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/deposits`, {params: {...filters}})
  },

  show(id) {
    return Http.get(`/deposits/${id}`);
  },
  
  create(deposit){
    return Http.post(`/deposits`, {deposit: {...deposit}})
  },

  update(deposit){
    return Http.put(`/deposits/${deposit.id}`, {
      deposit: {...deposit},
    });
  },

  updateMany(deposits){
    return Http.put(`/deposits/update_many`, {
      deposits: {...deposits},
    });
  },
  updateWithFormData(deposit){
    return Http.put(`/deposits/${deposit.get('deposit[id]')}`, deposit);
  },

}
